module.exports = __webpack_public_path__ + "static/media/too-much-ink.e23ceb68.png";